/**
 * Trust Arch Cookie Consent Level Enum
 */
export enum CookieConsentLevel {
  UNSET = '',
  REQUIRED = 'permit 1 required',
  FUNCTIONAL = 'permit 1,2 functional',
  ADVERTISING = 'permit 1,2,3',
}
